import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { getMe } from './puzzleApi';
import { FREE_BOOK_TITLE, FREE_BOOK_URL } from './puzzleConfig';
import RankBadge from './RankBadge';
import './CaseFile.css';

const fontsUrl = 'https://fonts.googleapis.com/css2?family=Special+Elite&family=Libre+Franklin:ital,wght@0,400;0,600;0,800;1,400&display=swap';

const ThankYou = () => {
  const [state, setState] = useState({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;

    getMe()
      .then((data) => {
        if (!cancelled) {
          setState({ status: 'ready', player: data.player });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setState({ status: 'ready', player: null });
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const player = state.player;

  return (
    <div className="case-file-page">
      <Helmet>
        <title>Welcome, detective | Jerry Evanoff</title>
        <meta name="robots" content="noindex" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link rel="stylesheet" href={fontsUrl} />
      </Helmet>

      <main className="cf-folder">
        <span className="cf-tab">MYSTERY LIST</span>

        {state.status === 'loading' && <h1>One moment…</h1>}

        {state.status === 'ready' && !player && (
          <>
            <h1>Nothing to see here yet</h1>
            <p className="cf-brief">Play a case and join the list to see your rank here.</p>
          </>
        )}

        {player && (
          <>
            <h1>You're in, {player.nickname}</h1>

            <p className="cf-brief">
              {player.cleanSolves > 0
                ? <>You've been promoted to <RankBadge rank={player.rank} />.</>
                : <>Your rank is <RankBadge rank={player.rank} />. Solve a case clean (no hints) to move up the ladder.</>}
            </p>

            {player.nextRankIn !== null && (
              <p className="cf-brief cf-progress-counter">
                {player.nextRankIn} more clean {player.nextRankIn === 1 ? 'solve' : 'solves'} until your next promotion.
              </p>
            )}

            <div className="cf-member">
              {player.wins} wins · {player.points} points · {player.ppg} PPG · current streak {player.currentStreak} · best streak {player.bestStreak}
            </div>

            {player.ml_status === 'unconfirmed' && (
              <div className="cf-answered">
                One more step: check your inbox for a confirmation email and click the link to finish joining the list.
              </div>
            )}

            {player.ml_status === 'pending' && (
              <div className="cf-answered">
                You're saved as a player. Adding you to the email list is taking a little longer than usual and will finish on its own.
              </div>
            )}

            {FREE_BOOK_URL && (
              <>
                <h2>Your free book</h2>
                <p className="cf-brief">As a thank-you for joining, here's <em>{FREE_BOOK_TITLE}</em>, where Sam Norris's first case begins.</p>
                <a className="cf-cta cf-link-button" href={FREE_BOOK_URL} target="_blank" rel="noopener noreferrer">
                  Get the free book
                </a>
              </>
            )}

            <p className="cf-back-links">
              <Link to="/standings">See the standings</Link> · <Link to="/my-record">Your full record</Link>
            </p>
          </>
        )}

        <p className="cf-back">
          <Link to="/case-file">Back to the case file</Link>
        </p>
      </main>
    </div>
  );
};

export default ThankYou;
